import styled from 'styled-components';
import { colors } from '@/globalStyles';

export const LoaderSpiner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
  
  &:after {
    content: ' ';
    position: relative;
    border: 0.6rem solid ${colors.backgroundInput};
    border-left-color: ${colors.primary};
    transform: translateZ(0);
    animation: rotate 1.1s infinite linear;
    border-radius: 50%;
    width: 6rem;
    height: 6rem;
    display: block;
  }
`;

export const LoaderOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  background-color: rgba(255,255,255,0.7);
  z-index: 111;
`;
